enum LocationTypes {
  GET_USER_LOCATION = 'GET_USER_LOCATION',
}

export default LocationTypes;
